import type { Router } from 'vue-router';
import { inject } from 'vue';
import type { Client } from '@keyvue/one-api-client';
import { isArray } from 'lodash';

export default {
    register: (router: Router) => {
        router.beforeResolve(async (to, from, next) => {
            const client = inject<Client>('client');

            if (!client) {
                throw new Error('Failed to find client in route guard, did you initialize the api plugin?');
            }

            if (to.meta.anonymous === true) {
                return next();
            }

            await client.session.loadSession();

            if (!client.session.isLoggedIn) {
                return next({
                    name: 'login',
                    query: {
                        redirect: to.path,
                    },
                });
            }

            if (isArray(to.meta.allowedRoles) && !to.meta.allowedRoles.includes(client.session.currentUser?.keyflowRole?.value)) {
                return next({ name: 'flow-dashboard' });
            }

            return next();
        });
    },
};
